import './App.css';
import ViewData from './components/ExtractInvoiceData';
// src/index.js or src/App.js
import FileUpload from './components/FileUpload';
// import awsExports from './aws-exports'; // This file should have been generated by Amplify
// Amplify.configure(awsExports);


function App() { 
  return (
  
      <div className="App">
          <h1>Upload any Invoice to scan</h1>
          <FileUpload />
          <ViewData/>
      </div>
  );
}

export default App;
